import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { WorkflowConfigState } from '../../shared/state/workflow/workflow-config.state';
import { Store } from '@ngxs/store';
import { WorkflowConfig } from '../../shared/interfaces/workflows/WorkflowConfig';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteComponent, AutocompleteOptionComponent } from '@siemens/component-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { WORKFLOW_CONFIG_TYPES_TRANSLATIONS_RECORD } from '../../shared/interfaces/workflows/WorkflowConfigTypesTranslationsRecord';
import { WorkflowConfigDetailsSkeletonComponent } from './workflow-config-details-skeleton/workflow-config-details-skeleton.component';

@Component({
    selector: 'app-workflow-config-details',
    templateUrl: './workflow-config-details.component.html',
    imports: [
        ReactiveFormsModule,
        AutocompleteComponent,
        AutocompleteOptionComponent,
        TranslatePipe,
        WorkflowConfigDetailsSkeletonComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowConfigDetailsComponent {
    private store = inject(Store);

    protected isWorkflowConfigTypesLoading = this.store.selectSignal<boolean>(WorkflowConfigState.isLoading);

    public readonly workflowTypes = input<WorkflowConfig[]>();
    public readonly workflowConfigFormGroup = input<FormGroup>(new FormGroup({}));

    protected readonly WORKFLOW_CONFIG_TYPES_TRANSLATIONS_RECORD = WORKFLOW_CONFIG_TYPES_TRANSLATIONS_RECORD;

    protected readonly sortedWorkflowTypes = computed(() =>
        this.workflowTypes() ? [...this.workflowTypes()].sort((a, b) => a.name.localeCompare(b.name)) : []
    );
}
